import FullWidthImage from './FullWidthImage';
import formatPrismicData from '../../hocs/formatPrismicData';

export default formatPrismicData(FullWidthImage);



// WEBPACK FOOTER //
// ./src/client/js/view/components/FullWidthImage/index.js